import React, { useEffect, useState } from 'react';
import { TOAST } from '../chat/design-tokens.js';

export interface ToastProps {
    message: string;
    type?: 'error' | 'success' | 'info';
    duration?: number;
    onClose: () => void;
}

export const Toast: React.FC<ToastProps> = ({ message, type = 'info', duration = 3000, onClose }) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(false);
            setTimeout(onClose, 300); // Wait for fade out animation
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    if (!isVisible) return null;

    const variantMap = {
        error: TOAST.variant.error,
        success: TOAST.variant.success,
        info: TOAST.variant.default,
    } as const;

    return (
        <div
            role="alert"
            aria-live="assertive"
            className={`${TOAST.shell} ${variantMap[type]}`}
        >
            <span className={TOAST.message}>{message}</span>
            <button onClick={() => { setIsVisible(false); setTimeout(onClose, 300); }} className={TOAST.close} aria-label="Close notification">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>
        </div>
    );
};
